import React from 'react';
import { CheckCircle2Icon, StarIcon } from 'lucide-react';
import { quickQuotes } from '../data/content';
export function QuickProof() {
  return <section className="w-full bg-canvas py-16 md:py-20" data-id="element-128" data-mp="1f1e2gr8qak3">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-129" data-mp="3ix45hmkr5hf2">
        <h2 className="flex items-center justify-center gap-3 text-center font-display text-2xl font-extrabold tracking-tight text-ink md:text-3xl" data-id="element-130" data-mp="3nvfejv383nw8">
          <CheckCircle2Icon className="h-7 w-7 shrink-0 text-rose-500" aria-hidden="true" data-id="element-131" data-mp="39uuz98wioa7h" />
          Lo que dicen los profesionales que ya lo usan
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-132" data-mp="2zxqb53j424o1">
          {quickQuotes.map(quote => <li key={quote.author} className="flex h-full flex-col rounded-2xl border-l-4 border-rose-500 bg-white p-6 shadow-soft ring-1 ring-gray-200" data-id="element-133" data-mp="34vrrvht2drwc">
              <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-134" data-mp="135gbo011c50h">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-135" data-mp="z6zt6w1yhoyc" data-mpi={index} />)}
              </span>
              <p className="mt-4 text-[1.0625rem] leading-snug text-ink" data-id="element-136" data-mp="13zj4tnh32a0i">“{quote.quote}”</p>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-137" data-mp="141wybrw47e5y">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-plum-700 font-display text-xs font-bold text-rose-100" data-id="element-138" data-mp="gai28guxlt35">
                  {quote.initials}
                </span>
                <span className="min-w-0" data-id="element-139" data-mp="p8jzclbjo1l5">
                  <span className="block truncate font-display text-sm font-extrabold text-ink" data-id="element-140" data-mp="kb1yzjbleuor">
                    {quote.author}
                  </span>
                  <span className="block truncate text-xs text-gray-500" data-id="element-141" data-mp="20rwi6ihptz3u">
                    {quote.role} | {quote.city}
                  </span>
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}